import * as ko from "knockout";
import * as moment from "moment";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import Finito from "modules/finito-module";
import BaoMenu from "./../services/bao-menu";
import Guid from "./../factories/guid";
import BaoDialog from "./../factories/bao-dialog";
import finitoService from "./../services/finito-service";
import "./../bindings/bao-toolbar2";
import "./../bindings/bao-date-time-picker";
function InformationHistoryViewModel(formHistoryId, infoId, showHistoryCallback) {
    var self = this;
    self.History = ko.observableArray();
    self.TotalRows = ko.observable();
    self.PageSize = ko.observable(10);
    self.PageIndex = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Selection = ko.observableArray();
    self.HasSelection = ko.pureComputed(function () {
        return self.Selection().length > 0;
    });
    self.link = function (item) {
        if ($.isFunction(showHistoryCallback)) {
            showHistoryCallback(item);
        }
    };
    self.getAll = function () {
        return Bao.post("Information/GetAllHistory", JSON.stringify({
            id: formHistoryId,
            infoId: infoId
        })).then(function (result) {
            ko.map.fromJS(result, self.History);
        });
    };
    self.initialize = function () {
        self.getAll();
    };
}
export default InformationHistoryViewModel;